'use es6';

import promiseClient from 'hub-http/adapters/promiseClient';
import { hubapi } from 'hub-http/middlewares/hubapi';
import { createHubSpotterStack } from 'hubspotter-http/stacks/hubSpotter';
const apiHubSpotterClient = promiseClient(createHubSpotterStack(hubapi));
export default apiHubSpotterClient;